export default __webpack_public_path__ + "static/media/LocationMap.ef7169c2.jpg";